import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../../h2Api'

export const CREATE_INDEX = 'admin_maintenance_create_index'
export const DROP_INDEX = 'admin_maintenance_drop_index'
export const PERFORM_INDEX = 'admin_maintenance_perform_index'
export const CLEAR_USERS = 'admin_mainenance_clear_users'
export const INDEX_OLD_MANAGERS = 'admin_mainenance_index_old_managers'
export const CACHE_WAGES = 'admin_maintenance_cache_wages'
export const DROP_TEMPLATE_CACHE = 'admin_maintenance_drop_template_cache'
export const EXPIRE_JOB_LISTINGS = 'admin_maintenance_expire_job_listings'
export const RETRIEVE_JOB_LISTINGS = 'admin_maintenance_retrieve_job_listings'
export const AERIES_SYNC_USERS = 'admin_maintenance_aeries_sync_users'
export const AERIES_SYNC_COURSES = 'admin_maintenance_aeries_sync_courses'
export const SYNC_ALL = 'admin_maintenance_hubspot_sync_all'
export const SYNC_CONTACTS = 'admin_maintenance_hubspot_sync_contacts'
export const SYNC_COMPANIES = 'admin_maintenance_hubspot_sync_companies'
export const SYNC_EMAIL = 'admin_maintenance_hubspot_sync_email'
export const DEMO_USERS_CREATE = 'admin_maintenance_demo_users_create'
export const S3_ROSTER = 'admin_maintenance_s3_roster'
export const ADMIN_MAINTENANCE_USAGE_REPORT = 'ADMIN_MAINTENANCE_USAGE_REPORT'
export const ADMIN_MAINTENANCE_SCHOOL_REPORT = 'ADMIN_MAINTENANCE_SCHOOL_REPORT'

export const CREATE_ARCHIVE_PSR = 'admin_archive_psr'

export const indexFormsRoot = 'admin.maintenance.index.forms'

export const indexRestrictionsPath = suffix => {
  return `${indexFormsRoot}.indexRestrictions${suffix ? `.${suffix}` : ''}`
}

export const loadUsageReport = () => {
  return h2Api.get('/admin/maintenance/reports/usage')({
    type: ADMIN_MAINTENANCE_USAGE_REPORT
  })
}

export const loadSchoolRegistrationReport = () => {
  return h2Api.get('/admin/maintenance/reports/schools')({
    type: ADMIN_MAINTENANCE_SCHOOL_REPORT
  })
}

export const executeIndexAction = form => dispatch => {
  const action = form.action

  if (action === 'create') {
    dispatch(
      h2Api.post(
        '/admin/maintenance/index/create',
        form
      )({ type: CREATE_INDEX, kind: form.kind })
    )
  } else if (action === 'drop') {
    dispatch(
      h2Api.post(
        '/admin/maintenance/index/drop',
        form
      )({ type: DROP_INDEX, kind: form.kind })
    )
  } else if (action === 'perform') {
    dispatch(
      h2Api.post(
        '/admin/maintenance/index/perform',
        form
      )({ type: PERFORM_INDEX, kind: form.kind, subKind: form.subKind })
    )
  } else if (action === 'clearUsers') {
    dispatch(
      h2Api.post('/admin/maintenance/index/users/clear', form)({ type: CLEAR_USERS })
    )
  } else if (action === 'indexOldManagers') {
    //TODO: Remove me when done
    dispatch(
      h2Api.post(
        '/admin/maintenance/index/users/indexOldManagers',
        form
      )({ type: INDEX_OLD_MANAGERS })
    )
  }
}

export const s3Roster = form => dispatch => {
  return dispatch(h2Api.post('/admin/importer/s3/manual', form)({ type: S3_ROSTER }))
}

export const resetWagesCache = () => dispatch => {
  dispatch(h2Api.post('/admin/maintenance/cache/wages', {})({ type: CACHE_WAGES }))
}

export const createArchive = () => dispatch => {
  dispatch(
    h2Api.post(
      '/admin/maintenance/archive/portfolioreport',
      {}
    )({ type: CREATE_ARCHIVE_PSR })
  )
}

export const resetTemplateCache = () => dispatch => {
  dispatch(
    h2Api.post(
      '/admin/maintenance/cache/templates/reset',
      {}
    )({ type: DROP_TEMPLATE_CACHE })
  )
}

export const expireJobOpenings = () => dispatch => {
  dispatch(
    h2Api.post(
      '/admin/maintenance/jobs/expireold',
      {}
    )({ type: EXPIRE_JOB_LISTINGS })
  )
}

export const retrieveJobOpenings = () => dispatch => {
  dispatch(
      h2Api.post(
          '/admin/maintenance/jobs/retrieve',
          {}
      )({ type: RETRIEVE_JOB_LISTINGS })
  )
}

export const aeriesSyncUsers = () => dispatch => {
  dispatch(h2Api.get('/aeries/students')({ type: AERIES_SYNC_USERS }))
}

export const aeriesSyncCourses = () => dispatch => {
  dispatch(h2Api.get('/aeries/courses')({ type: AERIES_SYNC_COURSES }))
}

export const syncAll = () => dispatch => {
  dispatch(h2Api.get('/crm/sync/all')({ type: SYNC_ALL }))
}

export const syncContacts = () => dispatch => {
  dispatch(h2Api.get('/crm/sync/contacts')({ type: SYNC_CONTACTS }))
}

export const syncEmail = () => dispatch => {
  dispatch(h2Api.get('/crm/sync/email')({ type: SYNC_EMAIL }))
}

export const clearUsers = () => dispatch => {
  dispatch(formActions.change(indexRestrictionsPath('action'), 'clearUsers'))
}

export const indexOldManagers = () => dispatch => {
  dispatch(formActions.change(indexRestrictionsPath('action'), 'indexOldManagers'))
}

export const dropIndex = kind => dispatch => {
  dispatch(formActions.change(indexRestrictionsPath('action'), 'drop'))
  dispatch(formActions.change(indexRestrictionsPath('kind'), kind))
  dispatch(formActions.change(indexRestrictionsPath('subKind'), ''))
}

export const createIndex = kind => dispatch => {
  dispatch(formActions.change(indexRestrictionsPath('action'), 'create'))
  dispatch(formActions.change(indexRestrictionsPath('kind'), kind))
  dispatch(formActions.change(indexRestrictionsPath('subKind'), ''))
}

export const performIndex = (kind, subKind) => dispatch => {
  dispatch(formActions.change(indexRestrictionsPath('action'), 'perform'))
  dispatch(formActions.change(indexRestrictionsPath('kind'), kind))
  dispatch(formActions.change(indexRestrictionsPath('subKind'), subKind))
}

export const indexTypes = [
  { kind: 'occupation', name: 'Occupations' },
  { kind: 'college', name: 'Colleges' },
  { kind: 'state', name: 'States' },
  { kind: 'district', name: 'Districts' },
  { kind: 'major', name: 'Majors' },
  { kind: 'industry', name: 'Industries' },
  { kind: 'military', name: 'Military' },
  { kind: 'profile', name: 'Profiles' },
  { kind: 'jobs', name: 'Job Openings' },
  { kind: 'certification', name: 'Certifications' },
  { kind: 'cms', name: 'CMS' },
  { kind: 'programs', name: 'Programs' },
  { kind: 'sitestats', name: 'Site Stats' },
  {
    kind: 'user',
    name: 'Users',
    subKinds: [
      { kind: 'assessment', name: 'Assessment' },
      { kind: 'content', name: 'Content' },
      { kind: 'plans', name: 'Plans (clear first)' },
      { kind: 'courses', name: 'Courses' },
      { kind: 'logging', name: 'Logging' },
      { kind: 'userfile', name: 'User Files (clear first)' },
      { kind: 'uniquerecords', name: 'Logging (uniqueRecords)' },
      { kind: 'early', name: 'UTL Index only' }
    ]
  }
]
